/**
 * File generated by js-routes 2.2.5
 * Based on Rails 6.1.7.3 routes of Ssb::Application
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const ModuleReferences = {
        CJS: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                module.exports = routes;
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                define([], function () {
                    return routes;
                });
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const UriEncoderSegmentRegex = /[^a-zA-Z0-9\-._~!$&'()*+,;=:@]/g;
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (true &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            return segment.replace(UriEncoderSegmentRegex, (str) => encodeURIComponent(str));
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return "(" + this.build_path_spec(route[1]) + ")";
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{},
    };
    Utils.define_module("ESM", result);
    return result;
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /:buuid/account(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/balance(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_balance_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"balance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/add_ibv_creative(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_ibv_creative_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_ibv_creative"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/geos/add_pois(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_pois_api_geos_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"geos"],[2,[7,"/"],[2,[6,"add_pois"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/add_traffic_to_campaigns(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_traffic_to_campaigns_api_campaigns_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"add_traffic_to_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/changes_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_changes_history_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"changes_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/gallery_file_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_gallery_file_stats_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"gallery_file_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/manage_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_manage_users_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"manage_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/preview_creative(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_preview_creative_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"preview_creative"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/sox_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sox_users_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"sox_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_tools_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/buyers/alerts(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alerts_api_buyers_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[6,"alerts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_ab_tests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algo_model_ab_test_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_ab_tests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_ab_tests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algo_model_ab_tests_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_ab_tests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_meta(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algo_model_meta_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_meta"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_meta_bundle_globals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algo_model_meta_bundle_global_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_meta_bundle_globals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_meta_bundle_globals/:algo_model_meta_bundle_global_id/algo_model_trains(.:format)
 * @param {any} algo_model_meta_bundle_global_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algo_model_meta_bundle_global_algo_model_train_bundle_globals_path = __jsr.r({"algo_model_meta_bundle_global_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_meta_bundle_globals"],[2,[7,"/"],[2,[3,"algo_model_meta_bundle_global_id"],[2,[7,"/"],[2,[6,"algo_model_trains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_meta_bundle_globals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algo_model_meta_bundle_globals_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_meta_bundle_globals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_meta/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algo_model_metum_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_meta"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_meta/:algo_model_metum_id/algo_model_trains(.:format)
 * @param {any} buuid
 * @param {any} algo_model_metum_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algo_model_metum_algo_model_trains_path = __jsr.r({"buuid":{"r":true},"algo_model_metum_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_meta"],[2,[7,"/"],[2,[3,"algo_model_metum_id"],[2,[7,"/"],[2,[6,"algo_model_trains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_trains/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algo_model_train_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_trains/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algo_model_train_bundle_global_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_stats(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algo_stats_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/audiences/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_audience_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"audiences"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/events_list(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_audience_events_list_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"events_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/audience_user_number(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_audience_user_number_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"audience_user_number"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/audiences(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_audiences_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"audiences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/auto_actions/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_auto_action_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"auto_actions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/auto_action_logs/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_auto_action_log_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"auto_action_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/auto_action_logs(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_auto_action_logs_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"auto_action_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/auto_actions(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_auto_actions_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"auto_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/boosts/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_boost_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"boosts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/boosts(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_boosts_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"boosts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/buyers/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_buyer_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/buyer_deals/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_buyer_deal_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"buyer_deals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/buyer_deals(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_buyer_deals_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"buyer_deals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/buyers/index(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_buyers_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/calculated_stat(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_calculated_stat_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"calculated_stat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:campaign_id/device_models(.:format)
 * @param {any} buuid
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_campaign_device_models_path = __jsr.r({"buuid":{"r":true},"campaign_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"device_models"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaign_ext_aggrs/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_campaign_ext_aggr_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaign_ext_aggrs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaign_ext_aggrs(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_campaign_ext_aggrs_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaign_ext_aggrs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaign_models/:campaign_id(.:format)
 * @param {any} buuid
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_campaign_models_path = __jsr.r({"buuid":{"r":true},"campaign_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaign_models"],[2,[7,"/"],[2,[3,"campaign_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaign_models/:campaign_id/boosts(.:format)
 * @param {any} buuid
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_campaign_models_boosts_path = __jsr.r({"buuid":{"r":true},"campaign_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaign_models"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"boosts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaign_models/:campaign_id/stats(.:format)
 * @param {any} buuid
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_campaign_models_stats_path = __jsr.r({"buuid":{"r":true},"campaign_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaign_models"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaign_skad/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_campaign_skad_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaign_skad"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_campaigns_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/templates/campaigns/:id(/:cb)(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_campaigns_templates_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"cb":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[1,[2,[7,"/"],[3,"cb"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/api/changes_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_changes_history_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"changes_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/converting_bundles(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_converting_bundles_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"converting_bundles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/creatives/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_creative_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/creative_gallery(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_creative_gallery_index_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"creative_gallery"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/creative_optimization(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_creative_optimization_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"creative_optimization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/creatives(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_creatives_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"creatives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/creatives_templates(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_creatives_templates_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"creatives_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/file_uploads(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_file_uploads_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"file_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/gallery_items(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_gallery_items_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"gallery_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/geos/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_geo_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"geos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/geos(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_geos_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"geos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/host_apps/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_host_app_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"host_apps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/host_apps(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_host_apps_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"host_apps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/api/hosting_apps_custom_labels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_hosting_apps_custom_labels_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"hosting_apps_custom_labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/api/hosting_apps_manage_index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_hosting_apps_manage_index_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"hosting_apps_manage_index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/lines_for_bundle(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_lines_for_bundle_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"lines_for_bundle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/moderate_creatives/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_moderate_creative_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"moderate_creatives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/moderate_creatives(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_moderate_creatives_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"moderate_creatives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/moderate_offer(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_moderate_offer_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"moderate_offer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/moderate_offer_check_domain(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_moderate_offer_check_domain_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"moderate_offer_check_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/moderate_offer_check_redirects(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_moderate_offer_check_redirects_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"moderate_offer_check_redirects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/notifications(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_notifications_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/offers/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_offer_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/offers(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_offers_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"offers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/report_schedules/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_report_schedule_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"report_schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/report_schedules(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_report_schedules_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"report_schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/rtb_stats/index(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_rtb_stats_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"rtb_stats"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/stats(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_stats_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/stats_presets(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_stats_presets_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"stats_presets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/stats_services_loggers(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_stats_services_loggers_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"stats_services_loggers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/tags/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_tag_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/tags(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_tags_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/creatives_templates/preview(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_template_html_preview_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"creatives_templates"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/templates/:c/:id(/:cb)(.:format)
 * @param {any} buuid
 * @param {any} c
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_templates_path = __jsr.r({"buuid":{"r":true},"c":{"r":true},"id":{"r":true},"cb":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"c"],[2,[7,"/"],[2,[3,"id"],[2,[1,[2,[7,"/"],[3,"cb"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/traffics/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_traffic_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"traffics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/traffics(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_traffics_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"traffics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/update_bundle_assets(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_bundle_store_assets_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"update_bundle_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/update_campaign_audience/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_campaign_audience_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"update_campaign_audience"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/api/update_hosting_app(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_hosting_apps_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"update_hosting_app"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/users/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/user_journey(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_journey_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_journey"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/users(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_users_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:campaign_id/line_suggestions(.:format)
 * @param {any} buuid
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_campaign_line_suggestions_path = __jsr.r({"buuid":{"r":true},"campaign_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"line_suggestions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/auto_action_logs/:id/apply(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apply_api_auto_action_log_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"auto_action_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /appreciate/optout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appreciate_optout_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"appreciate"],[2,[7,"/"],[2,[6,"optout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /appreciate/validate_tag(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appreciate_validate_tag_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"appreciate"],[2,[7,"/"],[2,[6,"validate_tag"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/buyers/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_buyer_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/creatives/:id/approve(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_creative_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/approved_creatives(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approved_creatives_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"approved_creatives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /appsflyer/audiences/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appsflyer_audience_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"appsflyer"],[2,[7,"/"],[2,[6,"audiences"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /appsflyer/audiences(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appsflyer_audiences_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"appsflyer"],[2,[7,"/"],[2,[6,"audiences"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/attach_file(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attach_file_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/offers/:id/attach_file(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attach_file_api_offer_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/stats/auctions_cost(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auctions_cost_stats_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"auctions_cost"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/stats/audience_graph(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audience_graph_stats_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"audience_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/audience_reach(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audience_reach_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"audience_reach"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/audit_creatives/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audit_creative_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_creatives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/auto_actions/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_action_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"auto_actions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/auto_actions(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_actions_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"auto_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/auto_media_plan_lines/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_media_plan_line_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"auto_media_plan_lines"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/auto_media_plan_lines(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_media_plan_lines_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"auto_media_plan_lines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/auto_media_scan(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_media_scan_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"auto_media_scan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/auto_plan_lines(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_plan_lines_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"auto_plan_lines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/balances/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const balance_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"balances"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/balances(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const balances_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"balances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/campaigns/bhistory(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bhistory_campaigns_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"bhistory"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/stats/bid_no_bid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bid_no_bid_stats_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"bid_no_bid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/bid_user_lists/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bid_user_list_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"bid_user_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/bid_user_lists(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bid_user_lists_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"bid_user_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/blacklist_traffic(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blacklist_traffic_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"blacklist_traffic"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/traffics/blacklist(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blacklist_traffics_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"traffics"],[2,[7,"/"],[2,[6,"blacklist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/blacklisted_lines(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blacklisted_lines_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"blacklisted_lines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/stats/blines(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blines_stats_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"blines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/blocked_lines(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blocked_lines_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"blocked_lines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_trains/:id/bq_config_file(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bq_config_file_algo_model_train_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bq_config_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_trains/:id/bq_config_file(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bq_config_file_algo_model_train_bundle_global_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bq_config_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/bstats(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bstats_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"bstats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/budget_lines(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_lines_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"budget_lines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/budget_lines_stats(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_lines_stats_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"budget_lines_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/budget_lines_stats_legacy(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_lines_stats_legacy_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"budget_lines_stats_legacy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/bulk_create(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_create_api_campaigns_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/bulk_create_template(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_create_template_api_campaigns_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"bulk_create_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/bundle_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bundle_categories_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bundle_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/bundle_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bundle_category_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bundle_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/tags/:id/bundles(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bundles_api_tag_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bundles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/buyers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/buyer_campaigns(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_campaigns_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"buyer_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/buyers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyers_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"buyers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/bundle_categories/:id/buyers_campaigns(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyers_campaigns_bundle_category_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bundle_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"buyers_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rtb/buyers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyers_rtb_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rtb"],[2,[7,"/"],[2,[6,"buyers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/stats/buyers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyers_stats_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"buyers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/stats/cache_flow(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cache_flow_stats_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"cache_flow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/stats/calculated_stats(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calculated_stats_api_stats_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"calculated_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/campaigns/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/campaigns/:id/moderate(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_moderate_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"moderate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/offers/:id/campaign(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_offer_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"campaign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/campaigns(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/stats/campaigns_alerts(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_alerts_api_stats_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"campaigns_alerts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/creatives/campaigns(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_api_creatives_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/campaigns/moderate(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_moderate_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"moderate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/carriers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carrier_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"carriers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/carriers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carriers_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"carriers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rtb/carriers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carriers_rtb_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rtb"],[2,[7,"/"],[2,[6,"carriers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/cdn_asset/:stk/:asset(.:format)
 * @param {any} buuid
 * @param {any} stk
 * @param {any} asset
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cdn_asset_path = __jsr.r({"buuid":{"r":true},"stk":{"r":true},"asset":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"cdn_asset"],[2,[7,"/"],[2,[3,"stk"],[2,[7,"/"],[2,[3,"asset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/creatives/change_animation_rate(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_animation_rate_creatives_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[6,"change_animation_rate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/users/change_language(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_language_api_users_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"change_language"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/buyers/:id/change_to(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_to_buyer_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_to"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/chart_stats(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chart_stats_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"chart_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/bundle_categories/check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_bundle_categories_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bundle_categories"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/clone(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_meta/:id/clone_ds(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_ds_algo_model_metum_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_meta"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone_ds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/creatives/:id/clone_to_live(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_to_live_creative_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone_to_live"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_trains/:id/config_file(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const config_file_algo_model_train_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"config_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_trains/:id/config_file(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const config_file_algo_model_train_bundle_global_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"config_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/config_updates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const config_updates_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"config_updates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/buyers/:id/configuration(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configuration_buyer_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rtb/configuration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configuration_rtb_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rtb"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/copy_blocked_traffic(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_blocked_traffic_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy_blocked_traffic"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/copy_creatives(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_creatives_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy_creatives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/copy_media_plan_to(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_media_plan_to_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy_media_plan_to"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/copy_models_from(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_models_from_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy_models_from"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_meta_bundle_globals/:id/copy_to_campaigns(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_to_campaigns_algo_model_meta_bundle_global_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_meta_bundle_globals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy_to_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/offers/countries(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const countries_api_offers_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[6,"countries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/gallery_items/create(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_api_gallery_items_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"gallery_items"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_meta/create_clicks(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_clicks_algo_model_meta_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_meta"],[2,[7,"/"],[2,[6,"create_clicks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_meta/create_default(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_default_algo_model_meta_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_meta"],[2,[7,"/"],[2,[6,"create_default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_meta/create_freezing(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_freezing_algo_model_meta_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_meta"],[2,[7,"/"],[2,[6,"create_freezing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/create_offer_and_campaign(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_offer_and_campaign_api_campaigns_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"create_offer_and_campaign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_meta/create_offline(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_offline_algo_model_meta_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_meta"],[2,[7,"/"],[2,[6,"create_offline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_meta/create_offline_based(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_offline_based_algo_model_meta_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_meta"],[2,[7,"/"],[2,[6,"create_offline_based"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/creatives/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creative_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/creative_rule/:id(.:format)
 * @param {any} buuid
 * @param {any} [campaign_id]
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creative_rule_path = __jsr.r({"buuid":{"r":true},"campaign_id":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"creative_rule"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/creatives(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creatives_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"creatives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/creatives(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creatives_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"creatives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/stats/creatives_by_name_csv(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creatives_by_name_csv_stats_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"creatives_by_name_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/creatives_gen(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creatives_gen_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"creatives_gen"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/creatives_stats(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creatives_stats_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"creatives_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/creatives_templates/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creatives_template_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"creatives_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/rtb_stats/csv(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csv_api_rtb_stats_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"rtb_stats"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/rtb_stats/db_settings(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const db_settings_api_rtb_stats_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"rtb_stats"],[2,[7,"/"],[2,[6,"db_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/deals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deal_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/deals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deals_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/delete_file(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_file_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/offers/:id/delete_file(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_file_api_offer_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/campaigns/:id/mpline/:uuid(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_plan_line_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mpline"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/geos/delete_pois(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_pois_api_geos_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"geos"],[2,[7,"/"],[2,[6,"delete_pois"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/campaigns/:id/msline/:uuid(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_scan_line_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"msline"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/delete_users_history_file(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_users_history_file_tools_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"delete_users_history_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/delete_users_history_postback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_users_history_postback_tools_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"delete_users_history_postback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/delete_users_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_users_history_tools_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"delete_users_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/device_ids_files(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const device_ids_files_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"device_ids_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_ab_tests/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_algo_model_ab_test_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_ab_tests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/disable(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/disabled_configs/:id/disable(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_disabled_config_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"disabled_configs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/creatives/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_ext_v2_creative_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/js_creatives/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_ext_v2_js_creative_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"js_creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/disabled_configs/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disabled_config_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"disabled_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/disabled_configs(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disabled_configs_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"disabled_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/docs/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const doc_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/docs(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docs_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_trains/:id/download_corrs(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_corrs_algo_model_train_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_corrs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_ab_tests/:id/download_csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_csv_algo_model_ab_test_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_ab_tests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/creatives/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_ext_v2_creative_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/media_plan_exports/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_media_plan_export_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"media_plan_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_trains/:id/download_output_model(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_output_model_algo_model_train_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_output_model"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_trains/:id/download_output_model(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_output_model_algo_model_train_bundle_global_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_output_model"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/dt_audience_lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dt_audience_list_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dt_audience_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/dt_audience_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dt_audience_lists_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dt_audience_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/account/dt_conv_test(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dt_conv_test_account_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"dt_conv_test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/account/edit(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_ab_tests/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_algo_model_ab_test_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_ab_tests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_meta_bundle_globals/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_algo_model_meta_bundle_global_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_meta_bundle_globals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_meta/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_algo_model_metum_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_meta"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_trains/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_algo_model_train_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_trains/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_algo_model_train_bundle_global_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/auto_actions/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_auto_action_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"auto_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/buyers/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_buyer_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/buyer_deals/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_buyer_deal_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"buyer_deals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaign_ext_aggrs/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_campaign_ext_aggr_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaign_ext_aggrs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/host_apps/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_host_app_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"host_apps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/moderate_creatives/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_moderate_creative_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"moderate_creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/offers/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_offer_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/report_schedules/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_report_schedule_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"report_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/tags/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_tag_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/traffics/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_traffic_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"traffics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/users/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_user_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /appsflyer/audiences/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_appsflyer_audience_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"appsflyer"],[2,[7,"/"],[2,[6,"audiences"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/auto_media_plan_lines/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_auto_media_plan_line_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"auto_media_plan_lines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/balances/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_balance_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"balances"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/bid_user_lists/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bid_user_list_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"bid_user_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/bundle_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bundle_category_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bundle_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/buyers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_buyer_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/campaigns/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/carriers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_carrier_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"carriers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/creatives/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_creative_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/deals/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_deal_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/disabled_configs/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_disabled_config_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"disabled_configs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/dt_audience_lists/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dt_audience_list_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dt_audience_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/exchange_configs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_exchange_config_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"exchange_configs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/file_uploads/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_file_upload_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"file_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/media_plan_exports/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_media_plan_export_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"media_plan_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/offers/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_offer_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_rails_conductor_inbound_email_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/rejected_contents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_rejected_content_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rejected_contents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/reports/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_report_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/report_schedules/:id/edit(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_report_schedule_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"report_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /singular/audiences/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_singular_audience_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"singular"],[2,[7,"/"],[2,[6,"audiences"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/enable(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/disabled_configs/:id/enable(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_disabled_config_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"disabled_configs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/creatives/:id/enable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_ext_v2_creative_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/js_creatives/:id/enable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_ext_v2_js_creative_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"js_creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/stats/events(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_api_stats_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_trains/:id/example_input(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const example_input_algo_model_train_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"example_input"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_trains/:id/example_input(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const example_input_algo_model_train_bundle_global_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"example_input"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/exchange_configs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exchange_config_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"exchange_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/exchange_configs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exchange_configs_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"exchange_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /exchange/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exchange_tags_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exchange"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ext/v1/campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v1_campaigns_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v1/creatives(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v1_creatives_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"creatives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v1/stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v1_stats_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/buyers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_buyer_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/buyers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_buyers_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"buyers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_campaign_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/campaigns/:campaign_id/creatives(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_campaign_creatives_path = __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"creatives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/campaigns/:campaign_id/image_creatives(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_campaign_image_creatives_path = __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"image_creatives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/campaigns/:campaign_id/js_creatives(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_campaign_js_creatives_path = __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"js_creatives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/campaigns/:campaign_id/native_creatives(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_campaign_native_creatives_path = __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"native_creatives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/campaigns/:campaign_id/plan_lines(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_campaign_plan_lines_path = __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"plan_lines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_campaigns_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/carriers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_carriers_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"carriers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/creatives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_creative_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/exchanges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_exchanges_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"exchanges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/image_creatives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_image_creative_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"image_creatives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/js_creatives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_js_creative_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"js_creatives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/native_creatives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_native_creative_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"native_creatives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/plan_lines/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_plan_line_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"plan_lines"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/scan_lines/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ext_v2_scan_line_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"scan_lines"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/boosts/feature_values(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feature_values_api_boosts_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"boosts"],[2,[7,"/"],[2,[6,"feature_values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/file_uploads/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_upload_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"file_uploads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/file_uploads(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_uploads_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"file_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/rtb_stats/filter_values(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filter_values_api_rtb_stats_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"rtb_stats"],[2,[7,"/"],[2,[6,"filter_values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/creative_gallery/filters(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filters_api_creative_gallery_index_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"creative_gallery"],[2,[7,"/"],[2,[6,"filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/stats/finance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finance_stats_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"finance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/traffics/find_list_lines(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_list_lines_api_traffics_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"traffics"],[2,[7,"/"],[2,[6,"find_list_lines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/geos/find_pois(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_pois_api_geos_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"geos"],[2,[7,"/"],[2,[6,"find_pois"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/assets/:id(/:file_id)(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gallery_asset_link_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"file_id":{},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[2,[1,[2,[7,"/"],[3,"file_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/geo_edge_alert_histories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const geo_edge_alert_histories_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"geo_edge_alert_histories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /geoedge/alert(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const geoedge_alert_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"geoedge"],[2,[7,"/"],[2,[6,"alert"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/offers/get_new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_new_api_offers_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[6,"get_new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/notifications/hide(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hide_api_notifications_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"hide"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/history(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const history_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/campaigns/:id/history(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const history_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/host_apps(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const host_apps_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"host_apps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/host/buyers(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const host_buyers_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"host"],[2,[7,"/"],[2,[6,"buyers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/host/reports(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const host_reports_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"host"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/buyer/hosted_buyers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hosted_buyers_ext_v2_buyer_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"buyer"],[2,[7,"/"],[2,[6,"hosted_buyers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/rtb_stats/ifa_lists(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ifa_lists_api_rtb_stats_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"rtb_stats"],[2,[7,"/"],[2,[6,"ifa_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/gallery_items/:id/ignore_ad_scans(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ignore_ad_scans_api_gallery_item_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"gallery_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ignore_ad_scans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/creatives/:id/image(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const image_creative_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/deals/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_deals_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deals"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/offers/impression_pixel_status(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const impression_pixel_status_api_offers_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[6,"impression_pixel_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/creatives/:id/initial_snippet(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const initial_snippet_creative_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"initial_snippet"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_trains/:id/input(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const input_algo_model_train_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"input"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_trains/:id/input(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const input_algo_model_train_bundle_global_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"input"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rtb/lal_add_bundle(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lal_add_bundle_rtb_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rtb"],[2,[7,"/"],[2,[6,"lal_add_bundle"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/line_creatives_stats(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const line_creatives_stats_api_campaigns_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"line_creatives_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/line_no_bid_stats(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const line_no_bid_stats_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"line_no_bid_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/traffics/list_csv/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const list_csv_traffics_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"traffics"],[2,[7,"/"],[2,[6,"list_csv"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/file_uploads/list_dt_apprec(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const list_dt_apprec_api_file_uploads_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"file_uploads"],[2,[7,"/"],[2,[6,"list_dt_apprec"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/file_uploads/list_dt_global(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const list_dt_global_api_file_uploads_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"file_uploads"],[2,[7,"/"],[2,[6,"list_dt_global"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/file_uploads/list_files(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const list_files_api_file_uploads_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"file_uploads"],[2,[7,"/"],[2,[6,"list_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/file_uploads/list_gs_bucket(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const list_gs_bucket_api_file_uploads_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"file_uploads"],[2,[7,"/"],[2,[6,"list_gs_bucket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/file_uploads/list_s3_bucket(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const list_s3_bucket_api_file_uploads_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"file_uploads"],[2,[7,"/"],[2,[6,"list_s3_bucket"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/file_uploads/list_s3_bucket_folders(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const list_s3_bucket_folders_api_file_uploads_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"file_uploads"],[2,[7,"/"],[2,[6,"list_s3_bucket_folders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/file_uploads/list_s3_multi_buckets(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const list_s3_multi_buckets_api_file_uploads_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"file_uploads"],[2,[7,"/"],[2,[6,"list_s3_multi_buckets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/traffics/lists(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lists_traffics_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"traffics"],[2,[7,"/"],[2,[6,"lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_trains/:id/log(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const log_algo_model_train_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_trains/:id/log(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const log_algo_model_train_bundle_global_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_trains/:id/log_bq_data(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const log_bq_data_algo_model_train_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"log_bq_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_trains/:id/log_bq_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const log_bq_data_algo_model_train_bundle_global_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"log_bq_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v1/campaigns/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_ext_v1_campaigns_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/look_alikes(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const look_alikes_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"look_alikes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/hosting_apps/manage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_hosting_apps_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hosting_apps"],[2,[7,"/"],[2,[6,"manage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/stats/manager_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manager_report_stats_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"manager_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/maxmind_carriers(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maxmind_carriers_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"maxmind_carriers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/media_plan_exports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_plan_export_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"media_plan_exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/media_plan_exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_plan_exports_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"media_plan_exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/media_scan_lines(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_scan_lines_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"media_scan_lines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/media_scan_lines_history(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_scan_lines_history_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"media_scan_lines_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/media_scan_lines_stats(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_scan_lines_stats_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"media_scan_lines_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/campaigns/memory_cache_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const memory_cache_check_campaigns_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"memory_cache_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/campaigns/memory_cache_warmup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const memory_cache_warmup_campaigns_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"memory_cache_warmup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/carriers/:id/merge(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const merge_carrier_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"carriers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rtb/mmp_data_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mmp_data_callback_rtb_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rtb"],[2,[7,"/"],[2,[6,"mmp_data_callback"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mp/:stk(.:format)
 * @param {any} stk
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mobile_preview_path = __jsr.r({"stk":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp"],[2,[7,"/"],[2,[3,"stk"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/stats/monitor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitor_stats_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"monitor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/mopub_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mopub_report_tools_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"mopub_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/creatives/:id/mraid(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mraid_creative_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mraid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/account/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_ab_tests/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_algo_model_ab_test_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_ab_tests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_meta_bundle_globals/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_algo_model_meta_bundle_global_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_meta_bundle_globals"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_meta_bundle_globals/:algo_model_meta_bundle_global_id/algo_model_trains/new(.:format)
 * @param {any} algo_model_meta_bundle_global_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_algo_model_meta_bundle_global_algo_model_train_bundle_global_path = __jsr.r({"algo_model_meta_bundle_global_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_meta_bundle_globals"],[2,[7,"/"],[2,[3,"algo_model_meta_bundle_global_id"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_meta/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_algo_model_metum_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_meta"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_meta/:algo_model_metum_id/algo_model_trains/new(.:format)
 * @param {any} buuid
 * @param {any} algo_model_metum_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_algo_model_metum_algo_model_train_path = __jsr.r({"buuid":{"r":true},"algo_model_metum_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_meta"],[2,[7,"/"],[2,[3,"algo_model_metum_id"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/auto_actions/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_auto_action_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"auto_actions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/buyers/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_buyer_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/buyer_deals/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_buyer_deal_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"buyer_deals"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_campaign_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaign_ext_aggrs/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_campaign_ext_aggr_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaign_ext_aggrs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/host_apps/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_host_app_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"host_apps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/moderate_creatives/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_moderate_creative_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"moderate_creatives"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/offers/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_offer_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/report_schedules/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_report_schedule_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"report_schedules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/tags/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_tag_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/traffics/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_traffic_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"traffics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/users/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_user_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /appsflyer/audiences/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_appsflyer_audience_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"appsflyer"],[2,[7,"/"],[2,[6,"audiences"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/auto_actions/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_auto_action_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"auto_actions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/auto_media_plan_lines/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_auto_media_plan_line_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"auto_media_plan_lines"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/balances/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_balance_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"balances"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/bid_user_lists/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_bid_user_list_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"bid_user_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/bundle_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_bundle_category_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bundle_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/buyers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_buyer_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/campaigns/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_campaign_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/carriers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_carrier_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"carriers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/creatives/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_creative_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/deals/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_deal_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deals"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/disabled_configs/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_disabled_config_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"disabled_configs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/dt_audience_lists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dt_audience_list_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dt_audience_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/exchange_configs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_exchange_config_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"exchange_configs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/file_uploads/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_file_upload_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"file_uploads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/media_plan_exports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_media_plan_export_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"media_plan_exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/offers/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_offer_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/orders/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_order_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/rejected_contents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rejected_content_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rejected_contents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/reports/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_report_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/report_schedules/new(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_report_schedule_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"report_schedules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /singular/audiences/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_singular_audience_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"singular"],[2,[7,"/"],[2,[6,"audiences"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaign_skad/:id/new_skad_set(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_skad_set_api_campaign_skad_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaign_skad"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_skad_set"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_meta/:algo_model_metum_id/algo_model_trains/new_upload(.:format)
 * @param {any} buuid
 * @param {any} algo_model_metum_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_upload_algo_model_metum_algo_model_trains_path = __jsr.r({"buuid":{"r":true},"algo_model_metum_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_meta"],[2,[7,"/"],[2,[3,"algo_model_metum_id"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[6,"new_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_confirmation_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_unlock_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/notifications(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /system/oarex(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oarex_index_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"oarex"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/offers/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offer_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/offers(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offers_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"offers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rtb/offline_train_end(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offline_train_end_rtb_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rtb"],[2,[7,"/"],[2,[6,"offline_train_end"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/orders/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/orders(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_trains/:id/output_extra_file(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const output_extra_file_algo_model_train_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"output_extra_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_trains/:id/output_extra_file(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const output_extra_file_algo_model_train_bundle_global_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"output_extra_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_trains/:id/output_extra_files(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const output_extra_files_algo_model_train_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"output_extra_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_trains/:id/output_extra_files(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const output_extra_files_algo_model_train_bundle_global_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"output_extra_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_trains/:id/output_model(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const output_model_algo_model_train_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"output_model"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_trains/:id/output_model(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const output_model_algo_model_train_bundle_global_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"output_model"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/orders/pay_result_offline(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pay_result_offline_orders_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"pay_result_offline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/orders/pay_result_zooz(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pay_result_zooz_orders_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"pay_result_zooz"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/creatives/:id/pend(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pend_creative_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/creatives/playables(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playables_api_creatives_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[6,"playables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:campaign_id/device_models/possible(.:format)
 * @param {any} buuid
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const possible_api_campaign_device_models_path = __jsr.r({"buuid":{"r":true},"campaign_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"device_models"],[2,[7,"/"],[2,[6,"possible"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/creatives/:id/preview(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_creative_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/creatives/:id/process_creative(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const process_creative_creative_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"process_creative"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /prometheus/metrics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prometheus_metrics_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"prometheus"],[2,[7,"/"],[2,[6,"metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/properties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_properties_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/routes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_routes_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"routes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/mailers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailers_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"mailers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/reachability(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reachability_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reachability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/stats/realtime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const realtime_stats_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"realtime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const register_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const register_new_buyer_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/creatives/reject(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reject_creatives_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/rejected_contents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejected_content_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rejected_contents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/rejected_contents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejected_contents_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rejected_contents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/rejected_creatives_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejected_creatives_check_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"rejected_creatives_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/related_campaigns(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const related_campaigns_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"related_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/reports/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/campaigns/:id/report/:type(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"type":{"r":true},"format":{"d":"csv"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v1/stats/report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_ext_v1_stats_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/report_schedules/:id(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_schedule_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"report_schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/report_schedules(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_schedules_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"report_schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/admin/reports(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/stats/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_stats_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/creatives/:id/rerun(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rerun_api_creative_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rerun"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/buyers/reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_buyers_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/reset_demo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_demo_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reset_demo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/reset_media_scan(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_media_scan_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_media_scan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/resque
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resque_server_path = __jsr.r({}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"resque"]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/restart_live_scan(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restart_live_scan_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restart_live_scan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/media_plan_exports/:id/restart(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restart_media_plan_export_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"media_plan_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/auto_action_logs/:id/revert(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revert_api_auto_action_log_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"auto_action_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revert"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /:buuid/lines/disable(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rtb_disable_line_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"lines"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /exchange/tags/rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rules_exchange_tags_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exchange"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/dt_audience_lists/:id/run_update(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const run_update_dt_audience_list_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dt_audience_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/campaigns/:id/scan_to_plan(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scan_to_plan_ext_v2_campaign_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"scan_to_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/host_apps/search(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_api_host_apps_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"host_apps"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/host_apps/search(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_host_apps_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"host_apps"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/creatives/:id/set_endcard(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_endcard_api_creative_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_endcard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_trains/:id/show_corrs(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_corrs_algo_model_train_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_corrs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/creatives_templates/:template_id/:filename(.:format)
 * @param {any} buuid
 * @param {any} template_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_creative_template_path = __jsr.r({"buuid":{"r":true},"template_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"creatives_templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[3,"filename"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /singular/audiences/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const singular_audience_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"singular"],[2,[7,"/"],[2,[6,"audiences"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /singular/audiences(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const singular_audiences_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"singular"],[2,[7,"/"],[2,[6,"audiences"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/skad_forwards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skad_forwards_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"skad_forwards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/skad_report(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skad_report_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"skad_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/stats/skad_report(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skad_report_api_stats_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"skad_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaign_skad/:id/skad_sets_index(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skad_sets_index_api_campaign_skad_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaign_skad"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"skad_sets_index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/tags/:id/snippet(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const snippet_api_tag_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"snippet"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/rtb_stats/splits_types(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const splits_types_api_rtb_stats_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"rtb_stats"],[2,[7,"/"],[2,[6,"splits_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/stats(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/stats(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/campaigns/:id/stats/country(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_country_ext_v2_campaign_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"country"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v1/campaigns/:id/stats(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_ext_v1_campaign_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v1/creatives/stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_ext_v1_creatives_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/buyers/stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_ext_v2_buyers_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/campaigns/:id/stats(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_ext_v2_campaign_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/campaigns/:campaign_id/creatives/stats(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_ext_v2_campaign_creatives_path = __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/campaigns/:campaign_id/plan_lines/stats(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_ext_v2_campaign_plan_lines_path = __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"plan_lines"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/campaigns/:campaign_id/scan_lines/stats(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_ext_v2_campaign_scan_lines_path = __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"scan_lines"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/campaigns/stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_ext_v2_campaigns_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/stats_services_loggers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_services_loggers_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"stats_services_loggers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /status/health(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_health_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"status"],[2,[7,"/"],[2,[6,"health"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /status/live(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_live_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"status"],[2,[7,"/"],[2,[6,"live"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /status/ping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_ping_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"status"],[2,[7,"/"],[2,[6,"ping"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /status/ready(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_ready_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"status"],[2,[7,"/"],[2,[6,"ready"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /status/startup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_startup_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"status"],[2,[7,"/"],[2,[6,"startup"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /examples/stimulus_demo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stimulus_demo_examples_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"examples"],[2,[7,"/"],[2,[6,"stimulus_demo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ext/v2/campaigns/:id/submit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_ext_v2_campaign_path = __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ext"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const system_bstats_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/tag_preview/:buyer_id/:id/:api_token(.:format)
 * @param {any} buyer_id
 * @param {any} id
 * @param {any} api_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tag_preview_path = __jsr.r({"buyer_id":{"r":true},"id":{"r":true},"api_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"tag_preview"],[2,[7,"/"],[2,[3,"buyer_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"api_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tags_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/template_preview(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const template_preview_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"template_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/test_email(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_email_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tmt/alert(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tmt_alert_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tmt"],[2,[7,"/"],[2,[6,"alert"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/auto_actions_log(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_auto_actions_log_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"auto_actions_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/auto_creatives(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_auto_creatives_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"auto_creatives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/bloom_query_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_bloom_query_status_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"bloom_query_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/campaign_budget_changes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_campaign_budget_changes_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"campaign_budget_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/click_url_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_click_url_check_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"click_url_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/converting_bundles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_converting_bundles_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"converting_bundles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/cost_per_country(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_cost_per_country_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"cost_per_country"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/creative_tag(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_creative_tag_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"creative_tag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/find_bundle(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_find_bundle_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"find_bundle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/hosting_apps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_hosting_apps_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"hosting_apps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_index_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/lines_for_bundle(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_lines_for_bundle_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"lines_for_bundle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/moderate_campaign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_moderate_campaign_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"moderate_campaign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/moderate_campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_moderate_campaigns_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"moderate_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/moderate_creatives(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_moderate_creatives_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"moderate_creatives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/mraid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_mraid_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"mraid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/purge_deleted_lines(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_purge_deleted_lines_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"purge_deleted_lines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/replay_conversions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_replay_conversions_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"replay_conversions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/tools/tags_generator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tools_tags_generator_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"tags_generator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_trains/:id/top_users_graph(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const top_users_graph_algo_model_train_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"top_users_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_ab_tests/:id/total_stats(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const total_stats_algo_model_ab_test_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_ab_tests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"total_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/traffics/traffic_blacklist(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const traffic_blacklist_api_traffics_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"traffics"],[2,[7,"/"],[2,[6,"traffic_blacklist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/traffic_lines(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const traffic_lines_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"traffic_lines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/traffics/traffic_list_lines/:list_id(.:format)
 * @param {any} buuid
 * @param {any} list_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const traffic_list_lines_api_traffics_path = __jsr.r({"buuid":{"r":true},"list_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"traffics"],[2,[7,"/"],[2,[6,"traffic_list_lines"],[2,[7,"/"],[2,[3,"list_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/traffics/traffic_lists(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const traffic_lists_api_traffics_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"traffics"],[2,[7,"/"],[2,[6,"traffic_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /traffic_media_scans/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const traffic_media_scans_import_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"traffic_media_scans"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/traffic_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const traffic_stats_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"traffic_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/stats/types(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const types_api_stats_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/users/:id/unlock(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlock_api_user_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/carriers/unmapped(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unmapped_carriers_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"carriers"],[2,[7,"/"],[2,[6,"unmapped"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_ab_tests/:id/update_bid_prob(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_bid_prob_algo_model_ab_test_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_ab_tests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_bid_prob"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_ab_tests/:id/update_events_mapping(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_events_mapping_algo_model_ab_test_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_ab_tests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_events_mapping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rtb/update_lal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_lal_rtb_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rtb"],[2,[7,"/"],[2,[6,"update_lal"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/update_line_model(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_line_model_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_line_model"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/admin/algo_model_ab_tests/:id/update_user_prob(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_user_prob_algo_model_ab_test_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"algo_model_ab_tests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_user_prob"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/algo_model_meta/:algo_model_metum_id/algo_model_trains/upload(.:format)
 * @param {any} buuid
 * @param {any} algo_model_metum_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_algo_model_metum_algo_model_trains_path = __jsr.r({"buuid":{"r":true},"algo_model_metum_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"algo_model_meta"],[2,[7,"/"],[2,[3,"algo_model_metum_id"],[2,[7,"/"],[2,[6,"algo_model_trains"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/gallery_items/upload(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_api_gallery_items_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"gallery_items"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/geos/upload(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_api_geos_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"geos"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/creatives/upload_assets_pack(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_assets_pack_api_creatives_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[6,"upload_assets_pack"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/creatives/upload(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_creatives_path = __jsr.r({"buuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/upload_file(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_file_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/offers/:id/upload_file(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_file_api_offer_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /upload_ifa_list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_ifa_list_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"upload_ifa_list"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_confirmation_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/user_history(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_history_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"user_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /system/user_lists/update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_lists_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"user_lists"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password_expired(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_expired_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password_expired"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unlock_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /singular/validate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"singular"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/users/validate_password_requirements(.:format)
 * @param {any} buuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_password_requirements_api_users_path = __jsr.r({"buuid":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"validate_password_requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/tags/:id/videos(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const videos_api_tag_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"videos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/vsplit_plan_lines(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vsplit_plan_lines_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"vsplit_plan_lines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/plan_lines/:id/wildcard_stats(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wildcard_stats_api_plan_line_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"plan_lines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"wildcard_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:buuid/api/campaigns/:id/win_ratio(.:format)
 * @param {any} buuid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const win_ratio_api_campaign_path = __jsr.r({"buuid":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"buuid"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"win_ratio"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

